import EuroIcon from "@mui/icons-material/Euro";
import IconInput from "./IconInput";

export default function Price(props: any) {
  const { onChange, ...others } = props;

  function onPriceChange(e: any) {
    const { name, value } = e.target;
    if (isValidValue(value)) {
      onChange({
        target: {
          name,
          value: value ? parseInt(value) : value,
        },
      });
    }
  }

  return (
    <IconInput
      startComponent={<EuroIcon sx={{ marginRight: 2 }} />}
      onChange={onPriceChange}
      {...others}
    />
  );
}

function isValidValue(value: string) {
  return value === "" || (value !== "0" && /^(?:\d*)$/g.test(value));
}
